import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
  getPhpApiUrl,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";

export async function feedbackSubmit(feed) {
  //   var baseUser = await AsyncStorage.getItem("user");
  //   let user = JSON.parse(baseUser);
  const userId = await getLoggedInUser();

  let url = getApiUrl() + "/users/" + userId._id + "/feedback";
  return fetch(url, {
    method: "POST",
    headers: await getHeaderForAjax(),
    body: JSON.stringify(feed),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export async function getCredit() {
  const userId = await getLoggedInUser();
  let url = getPhpApiUrl() + "/user/" + "credit/" + userId._id;
  return fetch(url, {
    method: "GET",
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}
export async function getTransActions() {
  const userId = await getLoggedInUser();
  let url = getPhpApiUrl() + "/user/" + "transactions/" + userId._id;
  return fetch(url, {
    method: "GET",
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/services/SupportService.js